export interface ParsedCoachingMessage {
	/** The text following "Say this:" — the suggestion to speak aloud. */
	suggestion: string;
	/** Any remaining paragraphs after the suggestion — the coach's reasoning. */
	reasoning: string;
}

/**
 * Parses an AI coaching message to extract a "Say this:" suggestion from reasoning text.
 * Returns null if the message does not follow the pattern.
 */
export const parseCoachingMessage = (text: string): ParsedCoachingMessage | null => {
	const trimmed = text.trimStart();
	// The WWJS coach writes the prefix in markdown bold ("**Say this:**"); without this the card falls back to the whole
	// reply, reasoning included.
	const match = trimmed.match(
		/^(?:\*{1,2}|_{1,2})?\s*say this(?:\s*:\s*(?:\*{1,2}|_{1,2})?|\s*(?:\*{1,2}|_{1,2})\s*:)\s*/i
	);
	if (!match) return null;

	const withoutPrefix = trimmed.slice(match[0].length);
	const paragraphs = withoutPrefix.split(/\n\n+/);

	return {
		suggestion: paragraphs[0].trim(),
		reasoning: paragraphs.slice(1).join('\n\n').trim(),
	};
};
